var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.881,
    height: 49.123,
    viewBox: "0 0 40.881 49.123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-document-5309667",
    transform: "translate(-142.612 -30.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1",
    "data-name": "Tracciato 1",
    d: "M183.475,40.57a.832.832,0,0,0-.042-.139l0-.012c-.007-.018-.017-.033-.025-.051s-.016-.03-.024-.045h0a.839.839,0,0,0-.131-.176l-9.093-9.095a.832.832,0,0,0-.174-.132l-.045-.024c-.015-.008-.033-.018-.05-.025l-.015,0a.754.754,0,0,0-.138-.042h-.013a.793.793,0,0,0-.151-.015h-27.5a3.461,3.461,0,0,0-3.457,3.457V76.476a3.461,3.461,0,0,0,3.457,3.457h33.967a3.461,3.461,0,0,0,3.457-3.457V40.733a.818.818,0,0,0-.016-.153Zm-2.81-.665h-4.471a1.8,1.8,0,0,1-1.8-1.8V33.633l3.139,3.137Zm1.171,36.571h0a1.8,1.8,0,0,1-1.8,1.8H146.07a1.8,1.8,0,0,1-1.8-1.8V34.267a1.8,1.8,0,0,1,1.8-1.8h26.672V38.1a3.461,3.461,0,0,0,3.457,3.457h5.639V76.477Z",
    transform: "translate(0 0)",
    fill: "#004ef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2",
    "data-name": "Tracciato 2",
    d: "M212.181,367.14h-10.66a2.32,2.32,0,0,0,0,4.64h10.66a2.32,2.32,0,1,0,0-4.64Zm0,2.984h-10.66a.664.664,0,1,1,0-1.328h10.66a.664.664,0,0,1,0,1.328Z",
    transform: "translate(-51.012 -303.179)",
    fill: "#004ef2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3",
    "data-name": "Tracciato 3",
    d: "M212.178,425.53h-10.66a2.32,2.32,0,0,0,0,4.641h10.66a2.32,2.32,0,1,0,0-4.641Zm0,2.985h-10.66a.665.665,0,1,1,0-1.329h10.66a.665.665,0,1,1,0,1.329Z",
    transform: "translate(-51.008 -355.814)",
    fill: "#004ef2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgDoc);
export default __webpack_public_path__ + "static/media/SvgDoc.cd34f876ab527fee3e8d9999238e8af0.svg";
export { ForwardRef as ReactComponent };